import * as React from 'react';

import { AppProps } from 'next/app';

import createCache from '@emotion/cache';
import { CacheProvider, EmotionCache } from '@emotion/react';
import { StyledEngineProvider } from '@mui/material/styles';
import { init } from '@socialgouv/matomo-next';

import { MainPageLayout } from '@itp/talent/components/layout';
import { AppSkeleton } from '@itp/talent/components/layout/appSkeleton';
import {
  IS_E2E,
  MATOMO_JS_TRACKER_FILE,
  MATOMO_PHP_TRACKER_FILE,
  MATOMO_SITE_ID,
  MATOMO_URL,
} from '@itp/talent/constants/config';

import '../styles/global.css';
// import 'instantsearch.css/themes/satellite.css';

type AppPropsWithLayout = AppProps & {
  emotionCache?: EmotionCache;
};

export default function MyApp({ Component, pageProps }: AppPropsWithLayout) {
  const cache = createCache({
    key: 'css',
    prepend: true,
  });

  const matomoInitialized = React.useRef(false);

  React.useEffect(() => {
    if (!IS_E2E && MATOMO_URL && MATOMO_SITE_ID && matomoInitialized.current === false) {
      init({
        jsTrackerFile: MATOMO_JS_TRACKER_FILE,
        phpTrackerFile: MATOMO_PHP_TRACKER_FILE,
        siteId: MATOMO_SITE_ID,
        url: MATOMO_URL,
      });
    }
    return () => {
      matomoInitialized.current = true;
    };
  }, []);

  return (
    <StyledEngineProvider injectFirst>
      <CacheProvider value={cache}>
        <AppSkeleton>
          <MainPageLayout>
            <Component {...pageProps} />
          </MainPageLayout>
        </AppSkeleton>
      </CacheProvider>
    </StyledEngineProvider>
  );
}
